import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const HeaderConfig = ({ contactHref = '/contact', contactIsExternal = false }) => {
  const location = useLocation();
  const basePath = process.env.PUBLIC_URL || '';
  const isActive = !contactIsExternal && location.pathname === `${basePath}${contactHref}`;

  const [menuActive, setMenuActive] = useState(false);

  const MobileMenuHandler = () => {
    const offCanvasMenu = document.querySelector('.off-canvas-menu');
    if (offCanvasMenu) {
      offCanvasMenu.classList.add('active');
      setMenuActive(true);
    }
  };

  // Praćenje promjene klase "active" u slučaju da se zatvori izvan React-a
  useEffect(() => {
    const offCanvasMenu = document.querySelector('.off-canvas-menu');
    if (!offCanvasMenu) return;

    const observer = new MutationObserver(() => {
      setMenuActive(offCanvasMenu.classList.contains('active'));
    });

    observer.observe(offCanvasMenu, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  const buttonStyle = isActive
    ? { background: 'linear-gradient(90deg, #E12426 0%, #C61F20 69%, #B41214 100%)' }
    : {};

  return (
    <div className="header-action mt-lg-0">
      {contactIsExternal ? (
        <a
          href={contactHref}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-navigation-menu"
        >
          Contact us
        </a>
      ) : (
        <Link
          to={`${basePath}${contactHref}`}
          className="btn-navigation-menu"
          style={buttonStyle}
        >
          Contact us
        </Link>
      )}
      <button
        type="button"
        onClick={MobileMenuHandler}
        className="btn-menu"
        id="burger"
        aria-label="Menu"
        style={{ display: menuActive ? 'none' : 'block' }}
      >
        <i className="fa fa-bars" />
      </button>
    </div>
  );
};

export default HeaderConfig;
